import * as api from '../resources/manage-inventory.api';
import actionTypes from './action-types';

export const fetchOrderDetailsRequest = () => ({
  type: actionTypes.FETCH_ORDER_DETAILS_REQUEST,
  name: 'orderDetailsLoadingStatus',
});

export const fetchOrderDetailsSuccess = (orderDetails) => ({
  type: actionTypes.FETCH_ORDER_DETAILS_SUCCESS,
  orderDetails,
  name: 'orderDetailsLoadingStatus',
});

export const fetchOrderDetailsFailure = () => ({
  type: actionTypes.FETCH_ORDER_DETAILS_FAILURE,
  name: 'orderDetailsLoadingStatus',
});

export const fetchOrderDetails = (config) => async (dispatch, getState) => {
  try {
    const { session, manageInventory } = getState();
    const { locale } = session;
    const { userSelection } = manageInventory;

    const retailerId = userSelection.retailerId || config.retailerId || session.retailer.retailerId;

    const requestParams = {
      ...config,
      ...userSelection,
      retailerId,
      locale,
    };

    dispatch(fetchOrderDetailsRequest());

    const orderDetails = await api.fetchOrderDetails(requestParams);
    dispatch(fetchOrderDetailsSuccess(orderDetails));
  } catch (error) {
    console.error('FETCH_ORDER_DETAILS', error);
    dispatch(fetchOrderDetailsFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/fetch-order-details.actions.js